var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.67 41.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.85,3.89h9.81a2,2,0,0,1,2,2v6a0,0,0,0,1,0,0H4.84a0,0,0,0,1,0,0v-6a2,2,0,0,1,2-2Z",
    transform: "translate(9.03 -6) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,5.83S-6.07,14.4,10.6,31.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.82,15.62S8.73,19,15.68,26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.85,25.9H40.7a0,0,0,0,1,0,0v6a2,2,0,0,1-2,2H28.87a2,2,0,0,1-2-2v-6a0,0,0,0,1,0,0Z",
    transform: "translate(36.51 74.93) rotate(-135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.83,37.63s-8.56,10.1-25.23-6.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,27.84S22.62,32.94,15.68,26"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.07f85817a0c07ede494e76e37dce781b.svg";
export { ForwardRef as ReactComponent };